module.exports = __webpack_public_path__ + "static/media/layout-1.db34b0cc.svg";